exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.rules-active-circle {\n  height: 12px;\n  width: 12px;\n  display: block;\n  border-radius: 52%;\n  margin-left: 12px;\n}\n.rules-active-circle.active {\n    background-color: #6ac951;\n}\n.rules-active-circle.inactive {\n    background-color: #d4d4d4;\n}\n.rules-active-row-size {\n  width: 80px;\n}\n.invalid-group-warning {\n  background-color: #ffe5e5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4ca371ec","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/revenue/rules/TabRulesGroup.vue
// module id = 3093
// module chunks = 0